import { __spreadArray } from 'tslib';
import { LOG_LEVEL, payloadJsonProcessor, version } from '@mailbiz/tracker-core';
import randomcolor from 'randomcolor';

/**
 * Adds advertisement tracking functions
 */
function DebuggerPlugin(logLevel) {
    if (logLevel === void 0) { logLevel = LOG_LEVEL.debug; }
    var LOG;
    var tracker;
    var eventColour;
    var colours = {
        event: function () { return "color: White; background: " + eventColour + "; font-weight: bold; padding: 1px 4px; border-radius: 2px;"; },
        mailbizPurple: 'color: White; background: #6638B8; font-weight: bold; padding: 1px 4px; border-radius: 2px;',
        activated: 'color: White; background: #9E62DD; font-weight: bold; padding: 1px 4px; border-radius: 2px;',
        payload: 'color: White; background: #3748B8; font-weight: bold; padding: 1px 4px; border-radius: 2px;',
        json: 'color: White; background: #388AB8; font-weight: bold; padding: 1px 4px; border-radius: 2px;',
        schema: 'color: White; background: #268047; font-weight: bold; padding: 1px 4px; border-radius: 2px;',
        schemaVersion: 'color: White; background: #80265F; font-weight: bold; padding: 1px 4px; border-radius: 2px;'
    };
    var debug = function (style, message, extra) {
        var _a = extra !== null && extra !== void 0 ? extra : [''], extraMessage = _a[0], rest = _a.slice(1);
        LOG.debug.apply(LOG, __spreadArray(["v" + version + " %c" + tracker.namespace + "%c %c%s" + extraMessage,
            colours.mailbizPurple,
            '',
            style,
            message], rest));
    };
    function jsonInterceptor(encodeBase64) {
        var log = function (_json, data) {
            if (!data || !data['data'] || typeof data['data'] === 'object') {
                return;
            }
            var textData = data['data'];
            debug(colours.event(), 'Event', ['%c%s%c%s%c%s\n%o', colours.json, textData]);
        };
        return function (payloadBuilder, jsonForProcessing) {
            if (jsonForProcessing.length) {
                var _loop_1 = function (json) {
                    var data = json.json['data'];
                    if (Array.isArray(data)) {
                        data.forEach(function (d) {
                            log(json, d);
                        });
                    }
                    else {
                        log(json, data);
                    }
                };
                for (var _i = 0, jsonForProcessing_1 = jsonForProcessing; _i < jsonForProcessing_1.length; _i++) {
                    var json = jsonForProcessing_1[_i];
                    _loop_1(json);
                }
            }
            return payloadJsonProcessor(encodeBase64)(payloadBuilder, jsonForProcessing);
        };
    }
    return {
        logger: function (logger) {
            LOG = logger;
            logger.setLogLevel(logLevel);
        },
        activateBrowserPlugin: function (t) {
            tracker = t;
            debug(colours.activated, 'Tracker Activated');
        },
        beforeTrack: function (payloadBuilder) {
            eventColour = randomcolor({ luminosity: 'dark' });
            payloadBuilder.withJsonProcessor(jsonInterceptor(tracker.core.getBase64Encoding()));
            debug(colours.event(), 'Event', ['%c%s', colours.mailbizPurple, getEventType(payloadBuilder)]);
            payloadBuilder.build();
        },
        afterTrack: function (payload) {
            debug(colours.event(), 'Event', ['%c%s\n%o', colours.payload, 'Payload', payload]);
        }
    };
}
function getEventType(payloadBuilder) {
    var payload = payloadBuilder.getPayload();
    return payload['event'];
}

export { DebuggerPlugin };
//# sourceMappingURL=index.module.js.map
